export const InspectionItemType = {
  Inspection: 'inspection',
  Form: 'form',
  Page: 'page',
  Section: 'section',
  Question: 'question',
  Action: 'action',
  FormAction: 'form_action',
  Conditional: 'conditional_section',
};

export const IMAGE_REPORT_MAX_HEIGHT = {
  REGULAR: 493,
  THUMBNAIL: 170,
};
